import React,{useState} from "react";
import "./addcategories.css";
import WmModals from "../../../modals/Wm.Modals";
import AddedCategoriesList from "./AddedCategoriesList";
import { connect } from "react-redux";

// ACTION
import {
  addCategories,
  handleCategoryForBlogs,
} from "../../../services/actions/actions";
function AddCategories({
  isAddCategory,
  close,
  list,
  checkBoxHandler,
  isFetchCat,
  getCategory,
  onClickHitApi
}) {
  const [data,setData] = useState(list)
  const [filterVal,setFilterVal] = useState("")
  return (
    <React.Fragment>
      <WmModals show={isAddCategory} size="md" onHide={() => close()}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="border h-8 rounded overflow-hidden mt-3">
                <input type="text" className="px-3 h-full w-full" value={filterVal} onChange={(e) => setFilterVal(e.target.value)} placeholder="Search category" />
              </div>
            </div>
            <AddedCategoriesList
              getCategory={getCategory}
              list={list}
              filterVal={filterVal}
              isFetchCat={isFetchCat}
              className={"catogryWrapper"}
              checkBoxHandler={checkBoxHandler}
              setFilterVal={setFilterVal}
              onClickHitApi={onClickHitApi}
            />
            <div className="col-md-12">
              <div className="text-right mb-3 rounded">
                <button className="primary px-3 py-1 text-white rounded" onClick={() => close()}>Save</button>
              </div>
            </div>
          </div>
        </div>
      </WmModals>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    state,
  };
};
const mapDispatchToState = (dispatch) => {
  return {
    handleAddCategory: (value) => {
      dispatch(addCategories(value));
    },
    addCategoryBlog: (value) => {
      dispatch(handleCategoryForBlogs(value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToState)(AddCategories);
